import { render, staticRenderFns } from "./28.vue?vue&type=template&id=0e6686fc&scoped=true&"
var script = {}
import style0 from "./28.vue?vue&type=style&index=0&id=0e6686fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6686fc",
  null
  
)

export default component.exports